import { render, staticRenderFns } from "./warnConfig.vue?vue&type=template&id=2a2d102b&scoped=true&"
import script from "./warnConfig.vue?vue&type=script&lang=js&"
export * from "./warnConfig.vue?vue&type=script&lang=js&"
import style0 from "./warnConfig.vue?vue&type=style&index=0&id=2a2d102b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d102b",
  null
  
)

export default component.exports